import { useEffect, useState } from "react";

import { getMetaData, getTrackersPdf } from "helpers/dashboard/dashboard";
import { getAllTracker } from "helpers/reports/getTrackerReports";

import SwalAlertComp from "components/SwalAlert";

const useHomeDashboardData = (language) => {
    const [trackerAllEvents, setTrackerAllEvents] = useState(0);
    const [trackerAllEventsNum, setTrackerAllEventsNum] = useState(0);
    const [leadsAllEvents, setLeadsAllEvents] = useState(0);
    const [leadsAllEventsNum, setLeadsAllEventsNum] = useState(0);
    const [signalsLoading, setSignalsLoading] = useState(true);
    const [checkCardStatus, setCheckCardStatus] = useState(false);
    const [goingTrackerCardStatus, setGoingTrackerCardStatus] = useState(false);
    const [readyCardLinks, setReadyCardLinks] = useState([]);
    const [metaLoading, setMetaLoading] = useState(true);
    const [reportsLoading, setReportsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const response = await getAllTracker();
            if (response.status) {
                const allEvents = response?.data?.reports?.signals?.all_events;
                setTrackerAllEventsNum(allEvents ?? 0);
                setTrackerAllEvents(allEvents?.toLocaleString("en-US"));

                const leadsEvents = response?.data?.reports?.leads?.all_events;
                if (leadsEvents !== undefined) {
                    setLeadsAllEventsNum(leadsEvents);
                    setLeadsAllEvents(leadsEvents?.toLocaleString("en-US"));
                }
            } else {
                SwalAlertComp({
                    title: language?.delete_swal_modal?.failed ?? "Failed",
                    message: response.message && response.message,
                    icon: "error",
                });
            }
            setSignalsLoading(false);
        };

        fetchData();
    }, []);

    useEffect(() => {
        const loadMetaData = async () => {
            const response = await getMetaData();
            if (response.status) {
                const expiredCount = response?.data?.trackers?.expired_count;
                const nonCompletedCount =
                    response?.data?.trackers?.non_completed_count;

                if (expiredCount !== undefined && expiredCount > 0) {
                    setCheckCardStatus(
                        localStorage.getItem("checkCardStatus") !== "false",
                    );
                }
                if (
                    nonCompletedCount !== undefined &&
                    nonCompletedCount > 0
                ) {
                    setGoingTrackerCardStatus(
                        localStorage.getItem("goingTrackerCardStatus") !==
                            "false",
                    );
                }
            }
            setMetaLoading(false);
        };

        const loadReports = async () => {
            const response = await getTrackersPdf();
            if (response?.status) {
                setReadyCardLinks(response?.data?.links ?? []);
            }
            setReportsLoading(false);
        };

        loadMetaData();
        loadReports();
    }, []);

    const dismissCheckCard = () => {
        localStorage.setItem("checkCardStatus", "false");
        setCheckCardStatus(false);
    };

    const dismissGoingTrackerCard = () => {
        localStorage.setItem("goingTrackerCardStatus", "false");
        setGoingTrackerCardStatus(false);
    };

    return {
        trackerAllEvents,
        trackerAllEventsNum,
        leadsAllEvents,
        leadsAllEventsNum,
        signalsLoading,
        checkCardStatus,
        goingTrackerCardStatus,
        readyCardLinks,
        metaLoading,
        reportsLoading,
        dismissCheckCard,
        dismissGoingTrackerCard,
    };
};

export default useHomeDashboardData;
